import { z } from 'zod';

export const inactivityLogoutSchema = z.object({
  expiresInMinutes: z.number(),
  logoutWhenCloseBrowser: z.boolean(),
});

type InactivityLogoutSchemaType = z.infer<typeof inactivityLogoutSchema>;

const defaultValue: InactivityLogoutSchemaType = {
  expiresInMinutes: 10,
  logoutWhenCloseBrowser: true,
};

export const inactivityLogoutDefaultValue = JSON.stringify(defaultValue, null, '\t');
